import React, { useState } from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import { Button, Col, Form, Input, Row } from 'reactstrap'
import { GeoAltFill, Envelope } from 'react-bootstrap-icons'
import emailjs from '@emailjs/browser'
import { toast } from 'react-toastify'

const Info = () => {
    const { t } = useLanguage();
    const [formData, setFormData] = useState({
        full_name: '',
        email: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await emailjs.send(
                'service_dmz_roto',
                'template_itjunction',
                {
                    full_name: formData.full_name,
                    email: formData.email,
                    message: formData.message
                },
                '3cIb1sgzlfNqwBYS8'
            );

            toast.success('Thank you for your inquiry', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });

            setFormData({
                full_name: '',
                email: '',
                message: ''
            });
        } catch (error) {
            console.error('EmailJS error:', error);
            toast.error('Failed to send message. Please try again.', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id='website-responsive'>
            <div className='left-padding10rem1 pe-lg-0 pe-3 py-lg-5 py-4' style={{ backgroundColor: 'transparent', backgroundImage: 'linear-gradient(270deg, #FE9B1F 15%, #FFFFFF00 15%)', }}>
                <Row className='py-lg-5'>
                    <Col xs='12' lg='5' className=''>
                        <div className=''>
                            <h2 className='fs-ss-40 text-philos fw-800'>
                                {t('contact.title')}
                            </h2>
                        </div>
                        <div className='mt-lg-4 mb-lg-5 mb-4 mt-3 mb-4'>
                            <p className='fs-ss-18 text-mulish text-ss-black fw-500'>
                                {t('contact.subtitle')}
                            </p>
                        </div>
                        <div className=''>
                            <Form onSubmit={handleSubmit}>
                                <Input 
                                    className='mb-lg-4 mb-3' 
                                    type='text' 
                                    name='full_name' 
                                    placeholder='First Name and Last Name' 
                                    value={formData.full_name}
                                    onChange={handleChange}
                                    required 
                                    style={{ borderRadius: 0 }} 
                                />
                                <Input 
                                    className='mb-lg-4 mb-3' 
                                    type='email' 
                                    name='email' 
                                    placeholder='Email' 
                                    value={formData.email}
                                    onChange={handleChange}
                                    required 
                                    style={{ borderRadius: 0 }} 
                                />

                                <Input 
                                    className='mb-lg-4 mb-3' 
                                    type='textarea' 
                                    name='message' 
                                    placeholder='Message' 
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    style={{ borderRadius: 0 }} 
                                />

                                <Button type='submit' disabled={loading} style={{ width: '100%', borderRadius: 0 }}>
                                    {loading ? 'SENDING...' : 'SEND'}
                                </Button>
                            </Form>
                        </div>
                    </Col>

                    <Col lg='7' className='ps-lg-5 mt-lg-0 mt-5 d-flex justify-content-lg-end justify-content-sm-center'>
                        <div className='bg-img img-w8-1 d-flex align-items-center justify-content-center' style={{ backgroundImage: "url('/contact/Our-approach.webp')", width: '', height: '100%' }}>
                            <div className='d-grid justify-content-center'>
                            <div className='mb-lg-5 mb-4 mt-lg-0 mt-4'>
                                <h3 className='fs-ss-40 text-philos fw-800 text-white'>
                                    {t('contact.contactInfo')}
                                </h3>
                                </div>

                                <div className='mb-lg-4 mb-4'>
                                    <span target='_blank' rel='noreferrer' className='' style={{ textDecoration: 'none' }}>
                                        <GeoAltFill className='text-ss-primary fs-ss-30 me-3' />
                                        <span className='fs-ss-18 text-mulish fw-bold text-white'>
                                            Germany
                                        </span>
                                    </span>
                                </div>
                                
                                <div className='mb-lg-5 mb-4'>
                                    <a href='mailto:info@itjunction.de' className='' style={{ textDecoration: 'none' }}>
                                        <Envelope className='text-ss-primary fs-ss-30 me-3'/>
                                        <span className='fs-ss-18 text-mulish fw-bold text-white'>
                                            info@itjunction.de
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Info